export var ActionType;
(function(ActionType) {
    ActionType["CLEAR_SEARCH_HISTORY"] = "CLEAR_SEARCH_HISTORY";
    ActionType["POPULATE_FORM"] = "POPULATE_FORM";
    ActionType["POPULATE_HISTORY_ITEMS"] = "POPULATE_HISTORY_ITEMS";
    ActionType["SET_CUSTOMER_AGE"] = "SET_CUSTOMER_AGE";
    ActionType["SET_DATE"] = "SET_DATE";
    ActionType["SET_LOCATION_INPUT_VALUE"] = "SET_LOCATION_INPUT_VALUE";
    ActionType["SET_LOCATION"] = "SET_LOCATION";
    ActionType["SET_ERROR"] = "SET_ERROR";
    ActionType["SET_SHOW_DEST_LOCATION"] = "SET_SHOW_DEST_LOCATION";
    ActionType["SET_SEARCH_FROM_HISTORY"] = "SET_SEARCH_FROM_HISTORY";
    ActionType["VALIDATE"] = "VALIDATE";
})(ActionType || (ActionType = {}));
export var isFormError = function(error) {
    return [
        "locationError",
        "dateError",
        "axiosError"
    ].includes(error);
};
